import React from 'react'
import { useConfig } from 'msp-integrations'
import { DynamicTag, transformRegionToMap } from '../../../index'
import { HeadlineSublineProps } from './HeadlineSubline.types'
import { getStyles } from './HeadlineSubline.styles'

const HeadlineSubline = ({ regions = [] }: HeadlineSublineProps) => {
  const {
    theme: {
      mspComponents: { headlineSubline }
    }
  } = useConfig()

  const HeadlineSublineStyles = getStyles(headlineSubline)
  const prelineItem =
    transformRegionToMap(regions)?.get('prelineRegion')?.components || []
  const headlineItem =
    transformRegionToMap(regions)?.get('headlineRegion')?.components || []
  return (
    <div className={HeadlineSublineStyles.wrapperStyles}>
      {prelineItem.length && (
        <div
          className={HeadlineSublineStyles.prelineWrapper}
          data-testid='test-preline-id'
        >
          <DynamicTag
            className={HeadlineSublineStyles.prelineStyles}
            componentTagName='Preline'
          >
            {prelineItem[0]?.data?.children}
          </DynamicTag>
        </div>
      )}
      {headlineItem.length && (
        <div
          className={HeadlineSublineStyles.headlineWrapper}
          data-testid='test-headline-id'
        >
          <DynamicTag
            className={HeadlineSublineStyles.headlineStyles}
            componentTagName='Headline'
          >
            {headlineItem[0]?.data?.children}
          </DynamicTag>
        </div>
      )}
    </div>
  )
}

export default HeadlineSubline
